import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyD26StaUK-1sjrON-KSmXld0NbwY4qvxBY",
  authDomain: "postflow-ai-e75b5.firebaseapp.com",
  projectId: "postflow-ai-e75b5",
  storageBucket: "postflow-ai-e75b5.firebasestorage.app",
  messagingSenderId: "909282361069",
  appId: "1:909282361069:web:856f55213dec2d529116e4",
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
const auth = getAuth(app);

const FUNCTIONS_BASE = "https://us-central1-postflow-ai-e75b5.cloudfunctions.net";
const ADMIN_EMAIL = "info@westmanns.fi";

const PLATFORM_LABELS = { instagram: "Instagram", linkedin: "LinkedIn", facebook: "Facebook", tiktok: "TikTok" };
const LANG_LABELS = { en: "English", fi: "Finnish", sv: "Swedish" };

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  :root {
    --bg: #0a0a0f; --surface: #12121a; --border: #1e1e2e;
    --accent: #00f5a0; --accent2: #00d9f5;
    --text: #e8e8f0; --muted: #b0b0cc; --danger: #ff4d6d;
  }
  body { background: var(--bg); color: var(--text); font-family: 'DM Sans', sans-serif; min-height: 100vh; }
  .admin { min-height: 100vh; background: var(--bg); padding: 2rem; max-width: 1100px; margin: 0 auto; }
  .admin-header { display: flex; align-items: center; gap: 1rem; margin-bottom: 2.5rem; padding-bottom: 1.5rem; border-bottom: 1px solid var(--border); }
  .logo { font-family: 'Bebas Neue', sans-serif; font-size: 1.8rem; background: linear-gradient(90deg, var(--accent), var(--accent2)); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
  .admin-badge { background: rgba(0,245,160,0.12); border: 1px solid rgba(0,245,160,0.3); color: var(--accent); border-radius: 999px; padding: 0.25rem 0.75rem; font-size: 0.75rem; font-weight: 600; }
  .back-link { margin-left: auto; font-size: 0.82rem; color: var(--muted); text-decoration: none; }
  .back-link:hover { color: var(--accent); }
  .stats-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 1rem; margin-bottom: 2rem; }
  @media (max-width: 768px) { .stats-grid { grid-template-columns: repeat(2, 1fr); } .admin { padding: 1rem; } }
  .stat-card { background: var(--surface); border: 1px solid var(--border); border-radius: 14px; padding: 1.5rem; }
  .stat-label { font-size: 0.72rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.1em; color: var(--muted); margin-bottom: 0.75rem; }
  .stat-value { font-family: 'Bebas Neue', sans-serif; font-size: 2.5rem; background: linear-gradient(90deg, var(--accent), var(--accent2)); -webkit-background-clip: text; -webkit-text-fill-color: transparent; line-height: 1; }
  .stat-sub { font-size: 0.75rem; color: var(--muted); margin-top: 0.4rem; }
  .section { background: var(--surface); border: 1px solid var(--border); border-radius: 14px; padding: 1.5rem; margin-bottom: 1.5rem; }
  .section-title { font-family: 'Bebas Neue', sans-serif; font-size: 0.75rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.12em; color: var(--muted); margin-bottom: 1.25rem; }
  .breakdown-row { display: flex; align-items: center; gap: 0.75rem; margin-bottom: 0.6rem; }
  .breakdown-name { font-size: 0.85rem; color: var(--text); width: 90px; }
  .breakdown-bar-wrap { flex: 1; background: var(--border); border-radius: 999px; height: 6px; overflow: hidden; }
  .breakdown-bar { height: 6px; border-radius: 999px; background: linear-gradient(90deg, var(--accent), var(--accent2)); transition: width 0.6s ease; }
  .breakdown-count { font-size: 0.8rem; color: var(--muted); width: 40px; text-align: right; }
  table { width: 100%; border-collapse: collapse; font-size: 0.82rem; }
  th { text-align: left; font-size: 0.72rem; text-transform: uppercase; letter-spacing: 0.08em; color: var(--muted); padding: 0 0 0.75rem; font-weight: 600; }
  td { padding: 0.6rem 0; border-top: 1px solid var(--border); color: var(--text); vertical-align: top; }
  td:last-child { color: var(--muted); font-size: 0.78rem; }
  .pill { display: inline-block; background: rgba(0,245,160,0.1); border: 1px solid rgba(0,245,160,0.2); color: var(--accent); border-radius: 999px; padding: 0.1rem 0.5rem; font-size: 0.72rem; margin: 0.1rem; }
  .anon { color: var(--muted); font-style: italic; }
  .loading { text-align: center; padding: 4rem; color: var(--muted); }
  .spinner { width: 28px; height: 28px; border: 2px solid var(--border); border-top-color: var(--accent); border-radius: 50%; animation: spin 0.8s linear infinite; margin: 0 auto 1rem; }
  @keyframes spin { to { transform: rotate(360deg); } }
  .error-box { background: rgba(255,77,109,0.08); border: 1px solid rgba(255,77,109,0.3); border-radius: 10px; padding: 1rem; color: #ff4d6d; text-align: center; }
  .forbidden { text-align: center; padding: 6rem 2rem; color: var(--muted); }
  .forbidden h2 { font-family: 'Bebas Neue', sans-serif; font-size: 2rem; color: var(--danger); margin-bottom: 0.75rem; }
`;

function BreakdownBar({ label, count, max }) {
  const pct = max > 0 ? (count / max) * 100 : 0;
  return (
    <div className="breakdown-row">
      <span className="breakdown-name">{label}</span>
      <div className="breakdown-bar-wrap">
        <div className="breakdown-bar" style={{ width: `${pct}%` }} />
      </div>
      <span className="breakdown-count">{count}</span>
    </div>
  );
}

function formatTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("fi-FI") + " " + d.toLocaleTimeString("fi-FI", { hour: "2-digit", minute: "2-digit" });
}

export default function AdminPage() {
  const [user, setUser] = useState(undefined);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, u => setUser(u));
    return () => unsub();
  }, []);

  useEffect(() => {
    if (user === undefined) return;
    if (!user || user.email !== ADMIN_EMAIL) { setLoading(false); return; }

    (async () => {
      try {
        const token = await user.getIdToken();
        const res = await fetch(`${FUNCTIONS_BASE}/getAdminStats`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        setStats(await res.json());
      } catch (e) {
        setError(e.message || "Failed to load stats");
      } finally {
        setLoading(false);
      }
    })();
  }, [user]);

  const platformMax = stats ? Math.max(...Object.values(stats.platformCounts || {}), 1) : 1;
  const langMax = stats ? Math.max(...Object.values(stats.langCounts || {}), 1) : 1;

  return (
    <>
      <style>{STYLES}</style>
      <div className="admin">
        <div className="admin-header">
          <div className="logo">Postlify AI</div>
          <span className="admin-badge">Admin</span>
          <Link to="/" className="back-link">← Back to app</Link>
        </div>

        {user === undefined || loading ? (
          <div className="loading"><div className="spinner" />Loading...</div>
        ) : !user || user.email !== ADMIN_EMAIL ? (
          <div className="forbidden">
            <h2>Access Denied</h2>
            <p>This page is restricted to admins.</p>
          </div>
        ) : error ? (
          <div className="error-box">{error}</div>
        ) : stats ? (
          <>
            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-label">Total Generations</div>
                <div className="stat-value">{stats.totalGenerations}</div>
                <div className="stat-sub">all time</div>
              </div>
              <div className="stat-card">
                <div className="stat-label">Today</div>
                <div className="stat-value">{stats.todayGenerations}</div>
                <div className="stat-sub">generations today</div>
              </div>
              <div className="stat-card">
                <div className="stat-label">Registered Users</div>
                <div className="stat-value">{stats.totalUsers}</div>
                <div className="stat-sub">Firebase Auth accounts</div>
              </div>
              <div className="stat-card">
                <div className="stat-label">Active Users</div>
                <div className="stat-value">{stats.activeUsers}</div>
                <div className="stat-sub">users who generated</div>
              </div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1.5rem", marginBottom: "1.5rem" }}>
              <div className="section">
                <div className="section-title">By Platform</div>
                {Object.entries(stats.platformCounts || {}).sort((a, b) => b[1] - a[1]).map(([p, c]) => (
                  <BreakdownBar key={p} label={PLATFORM_LABELS[p] || p} count={c} max={platformMax} />
                ))}
                {!Object.keys(stats.platformCounts || {}).length && <span style={{ color: "var(--muted)", fontSize: "0.85rem" }}>No data yet</span>}
              </div>
              <div className="section">
                <div className="section-title">By Language</div>
                {Object.entries(stats.langCounts || {}).sort((a, b) => b[1] - a[1]).map(([l, c]) => (
                  <BreakdownBar key={l} label={LANG_LABELS[l] || l} count={c} max={langMax} />
                ))}
                {!Object.keys(stats.langCounts || {}).length && <span style={{ color: "var(--muted)", fontSize: "0.85rem" }}>No data yet</span>}
              </div>
            </div>

            <div className="section">
              <div className="section-title">Recent Generations</div>
              {stats.recentGenerations?.length > 0 ? (
                <table>
                  <thead>
                    <tr>
                      <th>User</th>
                      <th>Industry</th>
                      <th>Platforms</th>
                      <th>Languages</th>
                      <th>Posts</th>
                      <th>Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {stats.recentGenerations.map(g => (
                      <tr key={g.id}>
                        <td>{g.userEmail ? g.userEmail : <span className="anon">anonymous</span>}</td>
                        <td>{g.industry || "—"}</td>
                        <td>{g.platforms?.map(p => <span key={p} className="pill">{PLATFORM_LABELS[p] || p}</span>)}</td>
                        <td>{g.langs?.map(l => <span key={l} className="pill">{LANG_LABELS[l] || l}</span>)}</td>
                        <td>{g.postsCount}</td>
                        <td>{formatTime(g.timestamp)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <span style={{ color: "var(--muted)", fontSize: "0.85rem" }}>No generations logged yet. Stats populate after the first use.</span>
              )}
            </div>
          </>
        ) : null}
      </div>
    </>
  );
}
